// Şifremi unuttum sayfası
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiMail, FiArrowLeft } from 'react-icons/fi';

const ForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  // Form gönderimi
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Email adresi gerekli');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Geçerli bir email adresi giriniz');
      return;
    }

    try {
      setIsLoading(true);
      setError('');
      await forgotPassword(email);
      setIsSubmitted(true);
    } catch (error) {
      setError('Email gönderilemedi. Lütfen tekrar deneyin.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen flex">
        {/* Sol taraf - Arka plan görseli */}
        <div 
          className="hidden lg:flex lg:w-3/5 relative overflow-hidden items-center justify-center"
          style={{ backgroundColor: '#dce6ff' }}
        >
          {/* Arka plan görseli - büyütülmüş ve ortalanmış */}
          <div 
            className="w-3/5 h-3/5 bg-contain bg-center bg-no-repeat"
            style={{
              backgroundImage: 'url(/login_background.jpg)',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          ></div>
        </div>

        {/* Sağ taraf - Başarı mesajı */}
        <div className="w-full lg:w-2/5 flex items-center justify-center bg-white p-4 sm:p-8">
          <div className="w-full max-w-md space-y-6 sm:space-y-8">
            {/* Logo */}
            <div className="text-left">
              <div className="mb-4">
                <img 
                  src="/apro_login_logo.png" 
                  alt="APRO Login Logo" 
                  className="w-auto h-16 object-contain"
                />
              </div>
            </div>

            {/* Başarı mesajı */}
            <div className="space-y-6">
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <FiMail className="h-6 w-6 text-green-600" />
                </div>
                <h3 className="mt-4 text-lg font-semibold text-gray-900">
                  Email Kontrol Edin
                </h3>
                <p className="mt-2 text-sm text-gray-600">
                  <strong>{email}</strong> adresine şifre sıfırlama linki gönderildi.
                  Email kutunuzu kontrol edin ve linke tıklayarak şifrenizi sıfırlayın.
                </p>
                <p className="mt-4 text-xs text-gray-500">
                  Email gelmediyse spam klasörünüzü kontrol edin.
                </p>
              </div>

              <Link
                to="/login"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg font-semibold transition-all duration-200 shadow-lg flex items-center justify-center"
              >
                <FiArrowLeft className="mr-2" size={16} />
                Giriş Sayfasına Dön
              </Link>
            </div>

            {/* Footer */}
            <div className="text-center pt-4 sm:pt-8">
              <p className="text-xs sm:text-sm text-gray-500">
                All rights reserved. © Copyright 2025 | APRO
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex">
      {/* Sol taraf - Arka plan görseli */}
      <div 
        className="hidden lg:flex lg:w-3/5 relative overflow-hidden items-center justify-center"
        style={{ backgroundColor: '#dce6ff' }}
      >
        {/* Arka plan görseli - büyütülmüş ve ortalanmış */}
        <div 
          className="w-3/5 h-3/5 bg-contain bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(/login_background.jpg)',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
      </div>

      {/* Sağ taraf - Forgot password formu */}
      <div className="w-full lg:w-2/5 flex items-center justify-center bg-white p-4 sm:p-8">
        <div className="w-full max-w-md space-y-6 sm:space-y-8">
          {/* Logo */}
          <div className="text-left">
            <div className="mb-4">
              <img 
                src="/apro_login_logo.png" 
                alt="APRO Login Logo" 
                className="w-auto h-16 object-contain"
              />
            </div>
          </div>

          {/* Başlık */}
          <div className="space-y-2">
            <h2 className="text-xl sm:text-2xl font-bold text-blue-600">Şifremi Unuttum</h2>
            <p className="text-sm sm:text-base text-gray-600">Email adresinizi girin, size şifre sıfırlama linki gönderelim</p>
          </div>

          {/* Form */}
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Email */}
            <div className="space-y-2">
              <label htmlFor="email" className="block text-sm font-semibold text-gray-700">
                Email Adresi
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <FiMail className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  className={`w-full pl-12 pr-4 py-3 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 ${
                    error 
                      ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                      : 'border-gray-300'
                  }`}
                  placeholder="Email adresinizi girin"
                />
              </div>
              {error && (
                <p className="text-sm text-red-600 flex items-center">
                  <span className="w-1 h-1 bg-red-600 rounded-full mr-2"></span>
                  {error}
                </p>
              )}
            </div>

            {/* Gönder butonu */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg h-12 flex items-center justify-center"
            >
              {isLoading ? (
                <span>Gönderiliyor...</span>
              ) : (
                'Şifre Sıfırlama Linki Gönder'
              )}
            </button>

            {/* Geri dön linki */}
            <div className="text-center pt-2">
              <Link
                to="/login"
                className="text-sm text-gray-600 hover:text-blue-500 font-medium transition-colors duration-200 flex items-center justify-center"
              >
                <FiArrowLeft className="mr-1" size={16} />
                Giriş Sayfasına Dön
              </Link>
            </div>
          </form>

          {/* Footer */}
          <div className="text-center pt-4 sm:pt-8">
            <p className="text-xs sm:text-sm text-gray-500">
              All rights reserved. © Copyright 2025 | APRO
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
